/**
 * PointsInfoCard - Info card explaining how the points system works
 */

import { useTranslation } from 'react-i18next';

interface PointsConfig {
  pointsPerService: number;
  noShowPenalty: number;
  expiredPenalty: number;
  lateCancellationPenalty: number;
}

interface PointsInfoCardProps {
  pointsConfig: PointsConfig;
}

export default function PointsInfoCard({ pointsConfig }: PointsInfoCardProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-surface border border-hairline rounded-xl p-6 mt-6">
      <h3 className="font-sans font-semibold text-ink mb-2">{t('profilePage.pointsSystem')}</h3>
      <div className="text-sm text-ink-muted space-y-1">
        <p>• <strong className="text-ink font-medium tabular-nums">+{pointsConfig.pointsPerService} {pointsConfig.pointsPerService === 1 ? t('profilePage.point') : t('profilePage.points')}</strong> {t('profilePage.perServiceCompleted')}</p>
        <p>• <strong className="text-ink font-medium tabular-nums">{pointsConfig.noShowPenalty} {t('profilePage.points')}</strong> {t('profilePage.perNoShow')}</p>
        <p>• <strong className="text-ink font-medium tabular-nums">{pointsConfig.expiredPenalty} {t('profilePage.points')}</strong> {t('profilePage.perExpired')}</p>
        <p>• <strong className="text-ink font-medium tabular-nums">{pointsConfig.lateCancellationPenalty} {t('profilePage.points')}</strong> {t('profilePage.perLateCancellation')}</p>
        <p className="mt-3 font-medium text-ink">{t('profilePage.negativePointsWarning')}</p>
      </div>
    </div>
  );
}
